/**
 * WhatsApp deep-link helper.
 * Opens a WhatsApp chat with a prefilled message.
 * Uses a synchronous `window.location.href` redirect for maximum device compatibility.
 */
export function buildWhatsAppUrl(phone: string, message: string): string {
  const sanitizedPhone = phone.replace(/[^\d]/g, '');
  return `https://wa.me/${sanitizedPhone}?text=${encodeURIComponent(message)}`;
}

export function openWhatsApp(phone: string, message: string): void {
  const url = buildWhatsAppUrl(phone, message);
  window.location.href = url;
}
